var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","md":"4"}},[_c('iframe',{attrs:{"src":"https://masterworks.looker.com/embed/dashboards/135","height":_vm.iFrameHeight,"width":_vm.iFrameWidth,"frameborder":"0"}})])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a89234d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/LookerStatistics.vue
// module id = 1200
// module chunks = 1